import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

type Props = ClassAttributes<HTMLElement> & {
  size?: number;
  className?: string;
};

const InstagramIcon = ({ size, className }: Props) => {
  const Root = styled('img')({
    width: size || 24,
    height: size || 24,
  });
  return <Root className={className} src="/assets/instagram_glyph_fill.png" />;
};

export default InstagramIcon;
